<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
                    <c-form-item type="input" label="任务名称:" name="task_name" placeholder="模糊匹配"></c-form-item>
                    <c-form-item type="input" label="代理:" name="agent_member_user" placeholder="昵称、手机号"></c-form-item>
                    <c-form-item type="input" label="商品名称" name="product_name" placeholder="模糊匹配"></c-form-item>
                    <c-form-item type="input" label="商品规格" name="product_sku_spec" placeholder="模糊匹配"></c-form-item>
                    <c-form-item type="input" label="SKU编码" name="product_sku_code" placeholder="模糊匹配"></c-form-item>
                    <c-form-item type="checkbox" label="任务状态:" name="task_state" :options="taskState"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button color="sys" power="b_gift_card_task_add" @click="openAddDialog">新建礼品卡生成任务</c-button>
                <c-button color="black" power="b_gift_card_page_config" style="margin-left: 10px;" @click="receivePageConfig">券码兑换页面配置</c-button>
			</m-operate>
			
			<c-table ref="table">
                <c-table-column
                    label="任务状态"
                    name="state"
                    width="80"
                >
					<template v-slot="{data}">
                        <span v-if="data.task_state == 1" style="color:dodgerblue">待生成</span>
                        <span v-if="data.task_state == 2" style="color:orange">生成中</span>
                        <span v-if="data.task_state == 3" style="color:green">已生成</span>
                        <span v-if="data.task_state == 5" style="color:red">生成失败</span>
					</template>
				</c-table-column>
                <c-table-column
                        label="任务执行信息"
                        name="task_exec_info"
                        width="140"
                >
                    <template v-slot="{data}">
                        <span v-if="data.task_state == 2 && data.task_exec_info" style="color:orange">{{data.task_exec_info}}</span>
                        <span v-if="data.task_state == 3" style="color:green">任务执行成功</span>
                        <span v-if="data.task_state == 5" style="color:red">任务执行失败：{{data.task_exec_info}}</span>
                    </template>
                </c-table-column>
				<c-table-column
					label="任务名称"
					name="task_name"
					width="140"
				></c-table-column>
				
				<c-table-column
                    label="代理头像/昵称/等级"
					name="agent_member_user"
					width="140"
				>
                    <template v-slot="{data}">
                        <div class="flex-center-cross" v-if="data.agent_member_user">
                            <c-image :src="data.agent_head_photo" preview size="40" style="margin-right: 10px;"></c-image>
                            <div>
                                <span>{{data.agent_nick_name||data.agent_mobilephone}}</span><br>
                                <span style="color:blue">{{data.level_name}}</span>
                            </div>
                        </div>
                    </template>
                </c-table-column>

				<c-table-column
					label="商品"
					name="product_sku"
					width="200"
				>
                    <template v-slot="{data}">
                        <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                        <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                    </template>
                </c-table-column>
                <c-table-column
                        label="规格"
                        name="product_sku_spec"
                        width="140"
                >
                </c-table-column>
                <c-table-column
                        label="sku编码"
                        name="product_sku_code"
                        width="140"
                >
                </c-table-column>

                <c-table-column
                        label="数量"
                        name="product_count"
                        width="100"
                ></c-table-column>

                <c-table-column
                        label="礼品卡数量"
                        name="card_count"
                        width="100"
                ></c-table-column>

                <c-table-column
                        label="起始卡号"
                        name="start_card_no"
                        width="100"
                ></c-table-column>

                <c-table-column
                        label="卡有效期"
                        name="card_valid_date"
                        width="290"
                >
                    <template v-slot="{data}">
                        {{data.valid_date_start}} - {{data.valid_date_end}}
                    </template>
                </c-table-column>

				<c-table-column
					label="创建人"
					name="create_user"
				></c-table-column>
				
				<c-table-column
					label="创建时间"
					name="create_date"
					width="140"
				></c-table-column>

                <c-table-column
                        label="生成人"
                        name="update_user"
                >
                    <template v-slot="{data}">
                        {{(data.task_state==2||data.task_state==3)?data.update_user:'--'}}
                    </template>
                </c-table-column>
				
				<c-table-column
					label="生成完成时间"
					name="update_date"
					width="140"
				>
                    <template v-slot="{data}">
                        {{(data.task_state==2||data.task_state==3)?data.update_date:'--'}}
                    </template>
                </c-table-column>

				<c-table-column
					type="button"
                    fixed="right"
					label="操作"
					width="150"
				>
					<template v-slot="row">
						<c-table-button power="b_gift_card_task_edit" v-if="row.data.task_state ==1" @click="openEditDialog(row.data)">编辑</c-table-button>
                        <c-table-button power="b_gift_card_task_create" v-if="row.data.task_state ==1 || row.data.task_state ==5" @click="createTask(row.data)">生成</c-table-button>
                        <c-table-button power="b_gift_card_task_detail" v-if="row.data.task_state ==2||row.data.task_state ==3"  @click="viewGiftCard(row.data)">查看礼品卡</c-table-button>
                        <c-table-button power="b_gift_card_task_voiding" v-if="row.data.can_voiding_count > 0"  @click="voidingGiftCard(row.data)">作废礼品卡</c-table-button>
                        <c-table-button power="b_gift_card_task_download" v-if="row.data.task_state ==3"  @click="downGiftCard(row.data)">下载</c-table-button>
						<c-table-button power="b_gift_card_task_delete" v-if="row.data.task_state ==1" @click="deleteTask(row.data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>

        <!-- 新增/编辑礼品卡任务弹框 -->
        <c-dialog
                ref="taskDialog"
                :title="taskDialogTitle"
                width="800px"
                @resolve="saveTask"
        >
            <c-form ref="taskForm" label-width="100px" >
                <c-form-item label="任务名称：" type="input" name="task_name" word="请填写礼品卡生成任务名称"  required></c-form-item>
                <c-form-item label="代理：" >
                    <c-button @click="$refs.memberSelector.open()" style="margin-top: 5px;">选择代理</c-button>
                    <c-button @click="selectedAgentMember={};" style="margin-top: 5px;margin-left: 5px;" hollow>清除</c-button>
                    <div v-if="selectedAgentMember.platform_user_id" class="selected-agent">
                        <div class="flex-center-cross">
                            <c-image :src="selectedAgentMember.head_photo" size="40" style="margin-right: 10px;"></c-image>
                            <div>
                                <span>{{selectedAgentMember.nick_name||selectedAgentMember.user_manage_mobilephone}}</span><br>
                                <span style="color:blue">{{selectedAgentMember.user_level_name}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="c-form-item-word">请选择礼品卡所属的代理</div>
                </c-form-item>
                <c-form-item label="商品："  required>
                    <c-button @click="$refs.productSelector.open()" style="margin-top: 5px;">选择商品SKU</c-button>
                    <div v-if="selectedProductSku.product_sku" class="selected-product">
                        <product-info :image="selectedProductSku.product_img_url"  :name="selectedProductSku.product_name">
                        </product-info>
                        <p style="margin-top: 5px">规格: {{selectedProductSku.product_sku_spec}}</p>
                        <p>SKU编码: {{selectedProductSku.product_sku_code}}</p>
                    </div>
                    <div class="c-form-item-word">请选择礼品卡兑换领取的商品</div>
                </c-form-item>
                <c-form-item label="商品数量：" type="number" name="product_count" word="请选择礼品卡兑换领取的商品数量"  required></c-form-item>
                <c-form-item type="datetime" date-type="datetime" label="领取时间：" word="请选择礼品卡使用的有效期，可选择到具体时间点" start-name="valid_date_start" end-name="valid_date_end" required></c-form-item>
                <c-form-item label="礼品卡数量：" type="number" name="card_count" :limit="[1,1000]" word="请填写礼品卡生成数量" required></c-form-item>
                <c-form-item label="起始卡号：" type="number" name="start_card_no"  word="请填写礼品卡起始卡号,即第一个卡号" :limit="[0,]" required></c-form-item>
            </c-form>
        </c-dialog>
        <member-selector ref="memberSelector" @resolve="selectAgentMemberHandle($event)"></member-selector>
        <product-selector ref="productSelector" sku @resolve="selectedProductSkuHandle($event)"></product-selector>

        <c-dialog
                ref="giftCardListDialog"
                :title="giftCardListDialogTitle"
                width="1200"
        >
            <module enable-flex>
                <m-search ref="gridCardSearch" @search="giftCardSearchHandle">
                    <c-form ref="gridCardSearchForm">
                        <c-form-item type="input" label="礼品卡号：" name="card_no"></c-form-item>
                        <c-form-item type="input" label="礼品卡编码：" name="card_code"></c-form-item>
                        <c-form-item type="input" label="领取人：" name="receive_member_user" placeholder="领取人昵称、手机号"></c-form-item>
                        <c-form-item type="checkbox" name="card_state" :options="cardState"></c-form-item>
                    </c-form>
                </m-search>
                <c-table ref="giftCardListTable" height="655">
                    <c-table-column
                            label="卡片状态"
                            name="card_state"
                    >
                        <template v-slot="{data}">
                            <span v-if="data.card_state == 0" style="color:blue">待领取</span>
                            <span v-if="data.card_state == 1" style="color:green">已领取</span>
                            <span v-if="data.card_state == 2" style="color:#999">已失效</span>
                            <span v-if="data.card_state == 3" style="color:red">已作废</span>
                        </template>
                    </c-table-column>
                    <c-table-column label="礼品卡号" name="card_no" width="110">
                    </c-table-column>
                    <c-table-column
                            label="礼品卡编码"
                            name="card_code"
                            width="120"
                    ></c-table-column>

                    <c-table-column
                            label="领取二维码"
                            name="qr_code_image"
                    >
                        <template v-slot="{data}">
                            <c-image :src="data.qr_code_image" preview size="40"></c-image>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="卡有效期"
                            name="card_valid_date"
                            width="290"
                    >
                        <template v-slot="{data}">
                            {{data.valid_date_start}} - {{data.valid_date_end}}
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="生成时间"
                            name="create_date"
                            width="140"
                    ></c-table-column>

                    <c-table-column
                            label="领取人"
                            name="receive_member_user"
                            width="140"
                    >
                        <template v-slot="{data}">
                            <div class="flex-center-cross" v-if="data.receive_member_user">
                                <c-image :src="data.receive_head_photo" preview size="40" style="margin-right: 10px;"></c-image>
                                <div>
                                    <span>{{data.receive_nick_name||data.receive_mobilephone}}</span><br>
                                    <span style="color:blue">{{data.receive_level_name}}</span>
                                </div>
                            </div>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="领取时间"
                            name="reveive_date"
                            width="140"
                    ></c-table-column>
                    <c-table-column
                            label="作废人"
                            name="voiding_user_name"
                    ></c-table-column>
                    <c-table-column
                            label="作废时间"
                            name="voiding_date"
                            width="140"
                    ></c-table-column>
                    <c-table-column
                            label="作废原因"
                            name="voiding_remark"
                            width="140"
                    ></c-table-column>
                </c-table>
            </module>
        </c-dialog>
        <c-dialog ref="receivePageConfigDialog" title="券码兑换页面配置" width="600" @resolve="submitReceivePageConfigForm">
            <c-form ref="receivePageConfigForm">
                <c-form-item type="image" label="页面背景图片" name="GIFT_CARD_PAGE_BG_IMAGE" v-model="GIFT_CARD_PAGE_BG_IMAGE" file-word="图片尺寸：750X1650"></c-form-item>
                <c-form-item label="页面背景色" name="GIFT_CARD_PAGE_BG_COLOR">
                    <div style="display: flex; align-items: center;">
                        <el-color-picker v-model="GIFT_CARD_PAGE_BG_COLOR"></el-color-picker>
                        <span style="margin-left: 5px;" v-if="GIFT_CARD_PAGE_BG_COLOR">{{GIFT_CARD_PAGE_BG_COLOR}}</span>
                    </div>
                </c-form-item>
                <c-form-item label="按钮背景色" name="GIFT_CARD_PAGE_BUTTON_BG_COLOR">
                    <div style="display: flex; align-items: center;">
                        <el-color-picker v-model="GIFT_CARD_PAGE_BUTTON_BG_COLOR"></el-color-picker>
                        <span style="margin-left: 5px;" v-if="GIFT_CARD_PAGE_BUTTON_BG_COLOR">{{GIFT_CARD_PAGE_BUTTON_BG_COLOR}}</span>
                    </div>
                </c-form-item>
                <c-form-item type="textarea" label="券码使用说明" name="GIFT_CARD_PAGE_USAGE_INSTRUCTIONS" v-model="GIFT_CARD_PAGE_USAGE_INSTRUCTIONS"></c-form-item>
            </c-form>
        </c-dialog>
        <c-dialog ref="voidingDialog" :title="voidingDialogTitle" width="600" @resolve="submitVoidingData">
            <c-form ref="voidingForm">
                <c-form-item type="textarea" label="作废原因" name="voiding_remark" v-model="voiding_remark"></c-form-item>
            </c-form>
        </c-dialog>
	</page>
</template>

<script>
	import productInfo from "@/components/public/product_info.vue";
    import memberSelector from "@/components/service/member_selector.vue";
    import productSelector from "@/components/service/product_selector.vue";

    export default {
		name: 'm_gift_card_task',
        components: {productSelector, memberSelector, productInfo},

		data() {
			return {
                taskState: [{
					name: '待生成',
					value: 1
				}, {
					name: '生成中',
					value: 2
				},{
                    name: '已生成',
                    value: 3
                },{
                    name: '生成失败',
                    value: 5
                }
                ],
                isEdit: false,
                taskDialogTitle: '新增礼品卡任务',
                taskId: '',
                selectedAgentMember: {},
                selectedProductSku: {},
                cardState: [{
                    name: '待领取',
                    value: 0
                }, {
                    name: '已领取',
                    value: 1
                }, {
                    name: '已失效',
                    value: 2
                }, {
                    name: '已作废',
                    value: 3
                }],
                detailTask: {
                    task_id:'',
                },
                GIFT_CARD_PAGE_BG_COLOR: '',
                GIFT_CARD_PAGE_BG_IMAGE: '',
                GIFT_CARD_PAGE_BUTTON_BG_COLOR: '',
                GIFT_CARD_PAGE_USAGE_INSTRUCTIONS: '',
                giftCardListDialogTitle: '查看任务礼品卡',
                // 作废原因
                voiding_remark: '',
                voidingDialogTitle: '作废任务礼品卡',
			}
		},

        watch: {
            defaultSearch(val) {
                this.$refs.searchForm.set(val);
                this.$nextTick(() => {
                    this.$refs.search.search();
                })
            }
        },

		computed: {
            defaultSearch() {
                return {};
            }
		},
		
		mounted() {
            this.$refs.searchForm.set(this.defaultSearch);
            this.$nextTick(() => {
                this.$refs.search.search();
            })
		},
		
		methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/giftCard/task/list',
                    data
                });
            },
            deleteTask(item) {
                this.$confirm({
                    text: '确定要删除礼品卡生成任务【' + item.task_name + '】吗？',
                    resolve: () => {
                        this.request({
                            url: '/giftCard/task/delete',
                            data: {
                                task_id: item.id
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: '删除成功'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },
            // 打开新增弹框
            openAddDialog() {
                this.isEdit = false;
                this.taskId = '';
                this.taskDialogTitle = '新增礼品卡生成任务';
                this.$refs.taskForm.clear();
                this.selectedAgentMember = {};
                this.selectedProductSku = {};
                this.$refs.taskDialog.open();
            },

            // 打开编辑弹框
            openEditDialog(task) {
                this.isEdit = true;
                this.taskId = task.id;
                this.taskDialogTitle = '编辑礼品卡生成任务';
                // 设置选中的代理和商品信息
                this.selectedAgentMember = {
                    platform_user_id: task.agent_member_user,
                    head_photo: task.agent_head_photo,
                    nick_name: task.agent_nick_name,

                    user_level_name: task.level_name
                };
                this.selectedProductSku = {
                    product_sku: task.product_sku,
                    product_img_url: task.product_img_url,
                    product_name: task.product_name,
                    product_sku_spec: task.product_sku_spec,
                    product_sku_code: task.product_sku_code
                };
                this.$refs.taskForm.set({
                    task_name: task.task_name,
                    product_count:task.product_count,
                    valid_date_start: task.valid_date_start,
                    valid_date_end: task.valid_date_end,
                    card_count: task.card_count,
                    start_card_no:task.start_card_no
                })
                this.$refs.taskDialog.open();
            },

            // 保存任务
            saveTask(stop) {
                stop();
                this.$refs.taskForm.submit(
                    {
                        url: this.taskId ? '/giftCard/task/update' : '/giftCard/task/add',
                        // 校验规则
                        rule: {
                            task_name: [{  // 字段名
                                type: 'empty',  // 校验类型
                                word: '请填写礼品卡生成任务名称'  // 提示文字
                            }],
                            product_sku: [{
                                type: 'function',
                                word: '请选择礼品卡兑换领取商品',
                                fun: () => {
                                    return !!this.selectedProductSku.product_sku;
                                }
                            }],
                            product_count: [{  // 字段名
                                type: 'empty',  // 校验类型
                                word: '请选择礼品卡兑换领取商品数量'  // 提示文字
                            }],
                            valid_date_start: [{
                                type: 'empty',  // 校验类型
                                word: '请选择有卡片有效期'
                            }],
                            valid_date_end: [{
                                type: 'empty',  // 校验类型
                                word: '请选择有卡片有效期'
                            }],
                            card_count: [{
                                type: 'empty',  // 校验类型
                                word: '请填写礼品卡生成数量'
                            }],
                            start_card_no: [{
                                type: 'empty',  // 校验类型
                                word: '请填写礼品卡起始卡号'
                            }],
                        },
                        dataFormatter: data => {
                            data.task_id = this.taskId;
                            data.agent_member_user = this.selectedAgentMember.platform_user_id;
                            data.product_sku = this.selectedProductSku.product_sku;
                            return data;
                        },
                        success: () => {
                            this.$message({
                                text: '保存成功'
                            });
                            this.$refs.taskDialog.close();
                            this.$refs.search.search();
                        }
                });
            },
            // 选择代理会员
            selectAgentMemberHandle(memeber) {
                if(memeber.length<=0){
                    this.$message({
                        text: '请选择代理会员'
                    });
                    return;
                }
                this.selectedAgentMember = memeber[0];
            },

            selectedProductSkuHandle(productSku){
                if (productSku.length<=0){
                    this.$message({
                        text: '请选择礼品卡商品'
                    });
                    return;
                }
                this.selectedProductSku = productSku[0];
            },
            createTask(task){
                this.$confirm({
                    text: '确定要进行任务【' + task.task_name + '】的礼品卡生成吗？',
                    resolve: () => {
                        this.request({
                            url: '/giftCard/generate',
                            data: {
                                task_id: task.id
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: '提交生成任务到后台处理成功，请稍后刷新列表查看'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },
            viewGiftCard( task){
                this.detailTask = task;
                this.giftCardListDialogTitle = '【'+task.task_name+'】任务礼品卡',
                this.$refs.giftCardListTable.load({
                    url: '/giftCard/list',
                    data: {"task_id":task.id}
                });

                this.$refs.giftCardListDialog.open();
            },
            giftCardSearchHandle(){
                var data = this.$refs.gridCardSearchForm.serialize();
                data.task_id = this.detailTask.id;
                this.$refs.giftCardListTable.load({
                    url: '/giftCard/list',
                    data: data
                });
            },
            downGiftCard(task){
                window.open(task.export_file_url);
            },
            receivePageConfig(){
                this.request({
                    url: '/giftCard/page/config',
                    loading: true,
                    success: (data) => {
                        this.$refs.receivePageConfigForm.clear();
                        this.GIFT_CARD_PAGE_BG_IMAGE = data.GIFT_CARD_PAGE_BG_IMAGE;
                        this.GIFT_CARD_PAGE_BG_COLOR = data.GIFT_CARD_PAGE_BG_COLOR;
                        this.GIFT_CARD_PAGE_BUTTON_BG_COLOR = data.GIFT_CARD_PAGE_BUTTON_BG_COLOR;
                        this.GIFT_CARD_PAGE_USAGE_INSTRUCTIONS = data.GIFT_CARD_PAGE_USAGE_INSTRUCTIONS;
                        this.$refs.receivePageConfigForm.set(data)
                        this.$refs.receivePageConfigDialog.open();
                    }
                });
            },
            submitReceivePageConfigForm(){
                this.request({
                    url: '/giftCard/page/updateConfig',
                    loading: true,
                    data: {
                        "platform_config_list": [
                            {"config_item_code": "GIFT_CARD_PAGE_BG_IMAGE","config_item_value": this.GIFT_CARD_PAGE_BG_IMAGE},
                            {"config_item_code": "GIFT_CARD_PAGE_BG_COLOR","config_item_value": this.GIFT_CARD_PAGE_BG_COLOR},
                            {"config_item_code": "GIFT_CARD_PAGE_BUTTON_BG_COLOR","config_item_value": this.GIFT_CARD_PAGE_BUTTON_BG_COLOR},
                            {"config_item_code": "GIFT_CARD_PAGE_USAGE_INSTRUCTIONS","config_item_value": this.GIFT_CARD_PAGE_USAGE_INSTRUCTIONS}
                        ]
                    },
                    success: (data) => {
                        this.$refs.receivePageConfigDialog.close();
                    }
                });
            },
            voidingGiftCard(row){
                // 获取符合自定义条件的行数据
                this.voiding_remark = '';
                this.taskId = row.id;
                this.voidingDialogTitle = '作废任务【' + row.task_name + '】的礼品卡';
                this.$refs.voidingDialog.open();
            },
            submitVoidingData(){
                this.request({
                    url: '/giftCard/task/voiding',
                    data: {
                        task_id: this.taskId,
                        voiding_remark: this.voiding_remark
                    },
                    loading: true,
                    success: () => {
                        this.$message({
                            text: '作废成功'
                        });
                        this.$refs.table.update();
                    },
                    error: () => {
                        this.$message({
                            text: '作废失败'
                        });
                    },
                    finally: () => {
                        this.voiding_remark = '';
                        this.taskId = '';
                        this.$refs.voidingDialog.close();
                    }
                });
            },
        }
	}
</script>

<style lang="stylus" scoped>.selected-agent, .selected-product {
    margin-top: 10px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    max-width: 600px
}
</style>